<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.22223 8.61112C2.22223 12.1333 5.0889 15 8.61112 15C10.0727 15 11.4215 14.5064 12.4993 13.6771L16.3555 17.5333C16.5178 17.6967 16.7311 17.7778 16.9444 17.7778H16.9455C17.1589 17.7778 17.3722 17.6956 17.5344 17.5333C17.86 17.2078 17.86 16.68 17.5344 16.3544L13.678 12.4981C14.5067 11.4204 15 10.0722 15 8.61112C15 5.0889 12.1333 2.22223 8.61112 2.22223C5.0889 2.22223 2.22223 5.0889 2.22223 8.61112ZM3.8889 8.61112C3.8889 6.00778 6.00778 3.8889 8.61112 3.8889C11.2145 3.8889 13.3333 6.00778 13.3333 8.61112C13.3333 11.2145 11.2145 13.3333 8.61112 13.3333C6.00778 13.3333 3.8889 11.2145 3.8889 8.61112Z"
            fill="currentColor"
        />
    </svg>
</template>
